import { render, staticRenderFns } from "./BulkOperations.vue?vue&type=template&id=27c1a6e0&scoped=true"
import script from "./BulkOperations.vue?vue&type=script&lang=ts"
export * from "./BulkOperations.vue?vue&type=script&lang=ts"
import style0 from "./BulkOperations.vue?vue&type=style&index=0&id=27c1a6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c1a6e0",
  null
  
)

export default component.exports